



































import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import jsPDF from 'jspdf';

@Component
export default class PreviewOutput extends Vue {
    constructor() {
        super();
    }

    get badgeClasses() {
        return {
            'badge': true,
            'badge-danger': this.integrationData.failedImport,
            'badge-success': this.integrationData.imported,
        };
    }

    get status() {
        let statusText = '';

        if (this.integrationData.imported) {
            statusText = this.$t('integrations.imported', 'Imported');
        } else if (this.integrationData.failedImport) {
            statusText = this.$t('integrations.import-failed', 'Importing Failed');
        }

        return statusText;
    }

    get integrationData() {
        return this.$store.getters['Integrations/getCurrentIntegrationSingleData'];
    }

    public cancel() {
        this.$store.commit(Mutations.SET_CURRENT_INTEGRATION_OUTPUT_OVERLAY_VISIBILITY, false);
    }

    public download() {
        const doc = new jsPDF();

        const step = 5;
        const pageStart = 20;
        let line = 20;
        let pageCounts = 0;

        const splitText = doc.splitTextToSize(this.integrationData.output, 180);

        while (pageCounts < splitText.length) {
            doc.text(splitText[pageCounts], 10, line);

            if (line >= 275) {
                doc.addPage();
                line = pageStart;
            }

            line += step;

            pageCounts++;
        }

        doc.save(this.integrationData.filename + '-integration-output.pdf');
    }
}
